import { useState, useEffect } from '@wordpress/element'
import { __ } from '@wordpress/i18n';
import { SelectControl } from '@wordpress/components';

export const DeliveryTimes = (props) => {
    if (!window.dhlpwc_block_data.deliverytimes_enabled) {
        return ''
    }

    const deliveryTimeShippingMethods = [
        'dhlpwc-home',
        'dhlpwc-home-evening',
        'dhlpwc-home-next-day',
        'dhlpwc-home-no-neighbour',
        'dhlpwc-home-no-neighbour-evening',
        'dhlpwc-home-no-neighbour-next-day',
    ]
    const [deliveryTimes, setDeliveryTimes] = useState({});
    const [selectedTime, setSelectedTime] = useState([]);

    useEffect(() => {
        const deliveryTimeDetails = document.getElementById('dhlpwc-shipping-method-delivery-times-option')
        if (deliveryTimeShippingMethods.indexOf(props.selectedShippingMethod) !== -1) {
            deliveryTimeDetails.style.display = "block";
            // Wordpress doesn't like it when we post raw data, so we post it as a form instead
            const formData = new FormData();
            formData.append('action', 'dhlpwc_get_delivery_times')
            formData.append('shipping_method', props.selectedShippingMethod)
            formData.append('postal_code', props.postalCode)
            formData.append('country_code', props.countryCode)
            fetch(
                window.dhlpwc_block_data['ajax_url'],
                {
                    method: 'POST',
                    body: formData
                }
            ).then(async response => {
                response = await response.json()
                let parsedDeliveryTimes = [];

                Object.values(response.data).forEach((value) => {
                    const parsedDeliveryTime = {
                        label: `${value.date} (${value.start_time} - ${value.end_time})`,
                        value: value.identifier
                    }
                    parsedDeliveryTimes.push(parsedDeliveryTime)
                })
                setDeliveryTimes(parsedDeliveryTimes)
                // initially set the first selection
                setSelectedTime(parsedDeliveryTimes[0].value.split('___'))
            })
        } else {
            deliveryTimeDetails.style.display = "none"
            setSelectedTime([])
        }
    }, [props.postalCode, props.countryCode, props.selectedShippingMethod])

    useEffect(() => {
        // Wordpress doesn't like it when we post raw data, so we post it as a form instead
        const formData = new FormData();
        formData.append('action', 'dhlpwc_delivery_time_selection_sync')

        formData.append('selected', true)
        formData.append('date', selectedTime[0] ?? '')
        formData.append('start_time', selectedTime[1] ?? '')
        formData.append('end_time', selectedTime[2] ?? '')

        fetch(
            window.dhlpwc_block_data['ajax_url'],
            {
                method: 'POST',
                body: formData
            }
        )
    }, [selectedTime])

    return <div id='dhlpwc-shipping-method-delivery-times-option'
                className='dhlpwc-shipping-method-delivery-times-option'>
        <div className="dhlpwc-delivery-times-selection-header">{__('DHL Delivery Times options')}</div>
        <span className="dhlpwc-delivery-times-selection-text">{__('Desired delivery moment:')}</span>
        <SelectControl
            hideLabelFromVision='true'
            className='dhlpwc-delivery-times-selection-input'
            label={__('Select desired delivery moment')}
            value={selectedTime.join('___')}
            options={deliveryTimes}
            onChange={(deliveryTime) => setSelectedTime(deliveryTime.split('___'))}
        />
    </div>
};
